import { useState } from "react";
import { toast } from "react-toastify";
import { getPaymentLinkAndQr } from "../utilities/paymentLink.api";

const usePaymentReminder = (token) => {
    const [loadingId, setLoadingId] =
        useState(null);

    const [paymentData, setPaymentData] =
        useState(null);

    const [
        showPaymentLinkModal,
        setShowPaymentLinkModal,
    ] = useState(false);

    const loadPaymentLinkModal = async (
        item,
        e
    ) => {
        try {
            setLoadingId(item.id);

            const res =
                await getPaymentLinkAndQr(
                    token,
                    item.id,
                    e
                );

            if (!res.success) {
                toast.error(res.error);
                return;
            }

            if (res.paymentLink) {
                setPaymentData(res);

                setShowPaymentLinkModal(true);
            } else {
                const encodedMsg =
                    encodeURIComponent(
                        res.reminderText
                    );

                const url = `https://wa.me/+91${res.mobile}?text=${encodedMsg}`;

                window.open(url, "_blank");
            }
        } catch (error) {
            toast.error(
                "Failed to generate payment reminder"
            );
        } finally {
            setLoadingId(null);
        }
    };

    const closePaymentModal = () => {
        setShowPaymentLinkModal(false);
        setPaymentData(null);
    };

    return {
        loadingId,
        paymentData,
        showPaymentLinkModal,
        loadPaymentLinkModal,
        closePaymentModal,
    };
};

export default usePaymentReminder;